export enum MenuLinkVisibilityEnum {
  "All" = 1,
  "Guest" = 2,
  "Registered" = 3,
  "Professional" = 4,
  "Customer" = 5,
}

export enum MenuLinkLocationEnum {
  "Header" = 1,
  "Footer" = 2,
  "Sidebar" = 3,
}

export enum MenuLinkEnum {
  // Default values
  DEFAULT_VISIBILITY = MenuLinkVisibilityEnum.All,
  DEFAULT_LOCATION = MenuLinkLocationEnum.Header,
}
